import api from '@/api/api'

class IcebreakerService {
  getIcebreakers(conversationId) {
    return api.axios.get(`icebreaker/get-available/${conversationId}`).then(response => response.data.icebreakers);
  }
}

export default new IcebreakerService();
